namespace _Ext.DialogUtils {
    export function pendingChangesConfirmation(element: JQuery, hasPendingChanges: () => boolean) {
        element.on('dialogbeforeclose panelbeforeclose', function (e) {
            if (!Serenity.WX.hasOriginalEvent(e)) {
                return;
            }

            if (!hasPendingChanges()) {
                return;
            }
            e.preventDefault();

            Swal.fire({
                title: 'Save Changes?',
                text: q.text('Controls.EntityDialog.PendingChangesConfirmation', 'You have pending changes. Save them?'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                focusConfirm: true                
            }).then((result) => {
                if (result.isConfirmed) {
                    element.find('div.save-and-close-button').click()
                }
                else {
                    if (element.hasClass('ui-dialog-content'))
                        element.dialog('close');
                    else if (element.hasClass('s-Panel'))
                        Serenity.TemplatedDialog.closePanel(element);
                }
                
            })
        });
    }
}
